import { useEffect } from 'react';
import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { Pagination } from 'components/common';
import { Box, BoxEmpty, BoxRow } from 'components/common/box';
import { FollowSearchType } from '.';

import type { PageState } from 'types';

const FollowSearch = () => {
  const { dispatch } = useDispatch();

  const { messages, pageState } = useReduxState();

  const updateData = async ({
    page,
    type
  }: {
    page?: number;
    type?: PageState['type'];
  }) => {
    const pageValue = page || pageState.page;
    const typeValue = type !== undefined ? type : pageState.type;

    try {
      dispatch(actions.updatePageState({ loading: true }));
      const url =
        `/admin/courses/${pageState.course.id}/analytics/search` +
        `?page=${pageValue}` +
        (typeValue ? `&type=${typeValue}` : '');
      const entries = await api.get(url);
      dispatch(
        actions.updatePageState({
          loading: false,
          page: pageValue,
          pages: entries.data.pages,
          searchData: entries.data.searchData,
          type: typeValue as PageState['type']
        })
      );
    } catch (err) {
      dispatch(actions.updatePageState({ loading: false }));
      await dispatch.handleErrorDispatch(err);
    }
  };

  useEffect(() => {
    updateData({});
  }, []);

  return (
    <div className="search-analytics">
      <Box
        headerContent={<FollowSearchType updateData={updateData} />}
        loading={pageState.loading}
        padding={0}
        title={messages.analyticsSearchAnalytics}
      >
        {pageState.searchData?.length ? (
          pageState.searchData.map((entry, i) => (
            <BoxRow key={i}>
              <div className="search-analytics-entry">
                <div className="row">
                  <div className="col">{entry.searchString}</div>
                  <div className="col-min">
                    <div className="search-analytics-entry-count">
                      {entry.count}
                    </div>
                  </div>
                </div>
              </div>
            </BoxRow>
          ))
        ) : (
          <BoxEmpty text={messages.commonNoData} />
        )}
      </Box>

      <Pagination
        currentPage={pageState.page}
        numberOfPages={pageState.pages}
        onPageChange={updateData}
      />

      <style jsx>{`
        .search-analytics-entry-count {
          min-width: 40px;
          text-align: right;
        }
      `}</style>
    </div>
  );
};

export default FollowSearch;
